import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MdmSkipTo from '~/components/atoms/Global/MdmSkipTo.vue';
export default {
  components: {
    MdmSkipTo: MdmSkipTo
  },
  data: function data() {
    return {
      hideNavigation: true,
      keyboardNavigationEnabled: true,
      skipLinks: [{
        text: this.$t('content'),
        to: '#main-content'
      }, {
        text: this.$t('navigation'),
        to: '#main-navigation'
      }]
    };
  },
  mounted: function mounted() {
    window.addEventListener('keyup', this.handleNavigation);
    document.addEventListener('keydown', this.handleKeyboardInput, true);
    document.addEventListener('click', this.handleMouseInput, true);
  },
  destroyed: function destroyed() {
    document.removeEventListener('keydown', this.handleKeyboardInput, true);
    document.removeEventListener('click', this.handleMouseInput, true);
  },
  methods: {
    handleNavigation: function handleNavigation(e) {
      if (e.keyCode !== 9) return;
      this.hideNavigation = !this.$el.contains(document.activeElement);
    },
    handleKeyboardInput: function handleKeyboardInput(e) {
      var isKeyboardKey = e.key === 'Tab' || e.code === 'Tab' || e.keyCode === 9 || e.keyCode === 38 || e.keyCode === 40;

      if (isKeyboardKey) {
        this.keyboardNavigationEnabled = true;
      }
    },
    handleMouseInput: function handleMouseInput() {
      if (this.keyboardNavigationEnabled) {
        this.keyboardNavigationEnabled = false;
      }

      this.$root.$emit('close-search-results');
    }
  },
  head: function head() {
    return {
      bodyAttrs: {
        class: this.keyboardNavigationEnabled ? 'is-using-keyboard' : ''
      }
    };
  }
};